export type ProjectStatus = 'Completed' | 'Draft' | 'Cancelled By Administrator' | 'Failed';

export const ProjectStatusValues: Record<ProjectStatus, ProjectStatus> = {
    Completed: 'Completed',
    Draft: 'Draft',
    'Cancelled By Administrator': 'Cancelled By Administrator',
    Failed: 'Failed',
};

export interface Project {
    id: string;
    name: string;
    createDate: string;
    userId: string;
    animationModeId?: string;
    genreId?: string;
    resolutionId: string;
    projectStatusId: string;
    generativeVideoIntegrationId?: string;
    audioSynchronizationId?: string;
    width: number;
    height: number;
    framesPerSeconds?: number;
    smoothness?: number;
    positiveKeyword?: string | string[]; // Backend returns as string[] (split by comma)
    negativeKeyword?: string | string[]; // Backend returns as string[] (split by comma)
    translation: unknown[];
    rotation: unknown[];
    dynamicCamera?: unknown;
    oscillation?: unknown;
    intensity?: unknown;
    useWatermark?: boolean;
    captionPosition?: string;
    audio: {
        action: number;
        tempFileId: string;
        filename: string;
        url: string;
        hasValue: boolean;
        isEmpty: boolean;
        itemId: string;
    };
    completedForm?: { url: string };
    video?: { url: string };
    status: ProjectStatus;
    minutes: number;
    isSubmitted: boolean;
    userName: string;
    completedPercentage: number;
    errorMessage?: string;

    // AWS Batch timing fields for tracking job lifecycle
    batchCreateTime?: string;
    batchStartTime?: string;
    batchStopTime?: string;

    // Computed properties for duration and wait time (from backend)
    batchDuration?: {
        totalSeconds: number;
        totalMinutes: number;
    };
    batchWaitTime?: {
        totalSeconds: number;
        totalMinutes: number;
    };
}
